import { Fragment } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import { TextInput, SelectInput } from 'react-admin';

const TakeoverDuration = (props) => {
  const form = useFormContext();
  const asset = useWatch({ name: 'asset' });
  const takeoverModeBool = useWatch({ name: 'takeoverModeBool' });
  const takeoverDuration = useWatch({ name: 'takeoverDuration' });

  if (!takeoverModeBool) {
    return <TextInput label="Takeover duration" source="takeoverDuration" disabled />;
  }

  if (!asset) {
    return (
      <Fragment>
        <TextInput label="Default duration" source="takeoverDuration" disabled />
        <Typography variant="caption">
          <p>Since there is no asset attached yet, default duration will be set:</p>
          <ul>
            <li>10 seconds for images</li>
            <li>Full length for videos</li>
          </ul>
        </Typography>
      </Fragment>
    );
  }

  let durationOptions = [
    { id: 'PT10S', name: '10 seconds' },
    { id: 'PT20S', name: '20 seconds' },
    { id: 'PT30S', name: '30 seconds' },
    { id: 'PT1M', name: '1 minute' },
  ];

  if (asset.resource_type === 'video') {
    durationOptions.unshift({ id: 'FULL_LENGTH', name: 'Full Length of Video' });
  }

  let defaultValue = durationOptions[0].id;

  if (!takeoverDuration) {
    form.setValue('takeoverDuration', defaultValue);
  }

  return (
    <SelectInput
      label="Takeover duration"
      source="takeoverDuration"
      initialValue={defaultValue}
      choices={durationOptions}
    />
  );
};

TakeoverDuration.propTypes = {};

export default TakeoverDuration;
